export const AlbumEventOrderType = {
	CUSTOM: 'custom',
	VIEWS:  'views',
	NEWEST: 'newest',
	OLDEST: 'oldest',
};
